module.exports =
{
	locale: 'en',
	long: require('./long.json'),
	long_time: require('./long-time.json'),
	long_convenient: require('./long-convenient.json'),
	short: require('./short.json'),
	short_time: require('./short-time.json'),
	short_convenient: require('./short-convenient.json'),
	narrow: require('./narrow.json'),
	tiny: require('./tiny.json'),
	quantify: require('./quantify')
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/locale/en/index.js
// module id = o3RT
// module chunks = 0